module.exports = __webpack_public_path__ + "static/media/code.acc30cde.svg";